module.exports = __webpack_public_path__ + "img/Avatar-3.d38b0a26.webp";